import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'

import { IAppState } from '../../../../store/IAppState'

import { StyledText as TextWrapper } from './style'

export const ProximaNova: FunctionComponent = (props) => {
  const { settings } = useSelector((state: IAppState) => ({
    settings: state.settings.values,
  }))

  // @ts-ignore
  const { children, highlight, ...restProps } = props

  // Filter out transient props (those starting with $) to prevent them from being passed to DOM/native components
  const filteredProps = Object.keys(restProps).reduce((acc, key) => {
    if (!key.startsWith('$')) {
      acc[key] = restProps[key]
    }
    return acc
  }, {} as Record<string, any>)

  if (typeof settings === 'undefined') {
    return null
  }

  return (
    <TextWrapper {...filteredProps} highlight={highlight || settings.highlightColor}>
      {children}
    </TextWrapper>
  )
}
